<template>
  <Card
    :title="$t('pages.ssr_features.pages.common.more_features.transcript.title')"
    :description="$t('pages.ssr_features.pages.common.more_features.transcript.description')"
    icon-name="Transcription"
    :link-url="$locatedLink('/features/episode-transcripts')"
  />
</template>

<script>
import Card from '../Card'

export default {
  components: {
    Card
  }
}
</script>
